import type { FocAiTourStepDef } from './focAiTourTypes';

export type FocAiTourApi = {
  openAiPanel: () => void;
  showReportsAi?: () => void;
  /**
   * Opens the Planning Section Chief workspace of the demo incident, where the
   * ICS 202 Generate button lives.
   */
  showIcs202Draft?: () => void;
};

let api: FocAiTourApi | null = null;

export function registerFocAiTourApi(next: FocAiTourApi): () => void {
  api = next;
  return () => {
    if (api === next) api = null;
  };
}

export function getFocAiTourApi(): FocAiTourApi | null {
  return api;
}

export function prepareFocAiTourStep(
  id: string,
  steps: readonly FocAiTourStepDef[]
): void {
  const step = steps.find((entry) => entry.id === id);
  const tour = step?.tour;
  if (!api) return;
  if (tour === 'reports-ai-generate' && api.showReportsAi) {
    api.showReportsAi();
    return;
  }
  if (tour === 'ics202-draft-ai' && api.showIcs202Draft) {
    api.showIcs202Draft();
    return;
  }
  api.openAiPanel();
}
